import Service from './Service';

export default class DeviceService extends Service {
    constructor() {
        super();
        this.baseURL = 'storemanagement/device/';
    }


}